<template>
  <button class="sticky-download" @click="$emit('download')">
    <span class="sticky-download__icon">↓</span>
    <span class="sticky-download__text">下载<br>App</span>
  </button>
</template>

<script>
export default {
  name: 'StickyDownload',
  emits: ['download'],
}
</script>

<style scoped>
.sticky-download {
  display: none;
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 90;
  background: var(--color-primary);
  color: var(--color-white);
  border-radius: var(--radius-md) 0 0 var(--radius-md);
  padding: 16px 10px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  box-shadow: -2px 0 12px rgba(0, 0, 0, 0.15);
  transition: background 0.2s;
}

.sticky-download:hover {
  background: #2d3b3a;
}

.sticky-download__icon {
  font-size: 16px;
}

.sticky-download__text {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
}

@media (min-width: 768px) {
  .sticky-download {
    display: flex;
  }
}
</style>
